import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/sidenav/sidenav-group.component.js'

const tagName = 'dap-ds-sidenav-group'

/**
 * `dap-ds-sidenav-group`
 * @summary Side navigation group
 * @element dap-ds-sidenav-group
 * @title - Side navigation group
 * @group side-navigation
 *
 * @slot - The content of the side navigation group.
 * @slot submenu - The submenu of the side navigation group.
 * @slot suffix - The suffix of the side navigation group.
 *
 * @csspart base - The main side navigation group container.
 * @csspart title - The title of the side navigation group.
 * @csspart link - The link of the side navigation group.
 * @csspart toggle - The toggle button of the side navigation group.
 * @csspart submenu - The submenu of the side navigation group.
 *
 * @cssproperty --dds-sidenav-group-margin-bottom - Default bottom margin of the sidenav group.
 * @cssproperty --dds-sidenav-group-border-radius - Border radius of the sidenav group.
 * @cssproperty --dds-sidenav-group-spacing-margin - Margin used for spacing variants.
 * @cssproperty --dds-sidenav-group-item-min-height - Minimum height of the sidenav group item.
 * @cssproperty --dds-sidenav-group-item-padding - Padding of the sidenav group item.
 * @cssproperty --dds-sidenav-group-item-color - Text color of the sidenav group item.
 * @cssproperty --dds-sidenav-group-item-font-size - Font size of the sidenav group item.
 * @cssproperty --dds-sidenav-group-item-font-weight - Font weight of the sidenav group item.
 * @cssproperty --dds-sidenav-group-item-bg-active - Background color when the item is active.
 * @cssproperty --dds-sidenav-group-item-bg-hover - Background color on hover and active states.
 * @cssproperty --dds-sidenav-group-toggle-margin - Margin for the toggle button.
 * @cssproperty --dds-sidenav-group-submenu-padding - Padding for the submenu.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSideNavGroup',
})

export default reactWrapper
